<template>
  <div>

    <!-- Header container -->
    <div class="header pb-6 d-flex align-items-center index-header">
      <!-- Mask
      <span class="mask bg-gradient-default opacity-8"></span>
      -->
      <div class="container align-items-center mt-9 mb-4">
        <div class="row mb-5">
          <div class="col-lg-8 col-md-8">
            <h1 class="display-3 text-white mt-0 mb-5 text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">Мессенджер доверенных коммуникаций для госкомпаний, юридических и физических лиц</h1>
            <div>
              <a href="#/home" class="btn base-button btn-secondary"><i class="fab fa-apple"></i> iOS <sup>скоро</sup></a>
              <a href="#/home" class="btn base-button btn-secondary"><i class="fab fa-android"></i> Android <sup>скоро</sup></a>
              <a href="https://storage.yandexcloud.net/komandor/release/Komandor-2.0.11.dmg" class="btn base-button btn-secondary"><i class="fab fa-apple"></i> macOS</a>
              <a href="https://storage.yandexcloud.net/komandor/release/Komandor%20Setup%202.0.11.exe" class="btn base-button btn-secondary"><i class="fab fa-windows"></i> Windows</a>
              <a href="https://storage.yandexcloud.net/komandor/release/komandor.desktop.app_2.0.11_amd64.deb" class="btn base-button btn-secondary"><i class="fab fa-ubuntu"></i> Ubuntu</a>
            </div>
            <h1 class="text-white mt-5" style="font-weight: 400">Попробуйте <span class="komandor">Командор<sup>®</sup></span> бесплатно и прямо сейчас</h1>
            <p class="text-white">Вам будет доступна безлимитная подписка на 2 недели, плюс 10 дополнительных подписаний когда подписка закончится.</p>
          </div>
          <div class="col-lg-4 col-md-4 d-flex align-items-center">
            <Logo style="margin: 0 auto" :color="color" :animation="true" :width="260"/>
          </div>
        </div>
        <div class="row">
          <div class="col border-left ml-3">
            <h2 class="font-weight-300 text-white">
              Необходимо иметь действующую квалифицированную электронную подпись (КЭП) выданную аккредитованным удостоверяющим центром.
              <!--Так же вы можете использовать не квалифицированный сертификат ЭП получив его в личном кабинете на сайте.-->
              <a href="#/howto" class="text-white"><i class="fas fa-info-circle"></i></a>
            </h2>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>

    <!-- 6 card -->
    <div class="container mt--6 mb-2">
      <!-- 1-3 cards -->
      <div class="row mb-5">
        <!-- Конфиденциально -->
        <div class="col-xl-4 col-md-6">
          <card class="h-100 mb-0">
            <div class="row mb-2">
              <div class="col-auto">
                <div class="icon icon-shape rounded-circle text-white"
                  style="background-image: url(/img/icons/1.png); height: 48px; width: 48px; background-position: center"><i class="fas fa-shield-alt"></i></div>
              </div>
              <div class="col ml--2 d-flex align-items-center" style="height: 48px">
                <h3 class="mb-0">Конфиденциально</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-body mb-1">Сквозное шифрование всех данных на вашем ключе.</p>
                <p class="text-body mb-0">Все сообщения обязательно шифруются на стороне клиента вашей ЭП.</p>
              </div>
            </div>
          </card>
        </div>

        <!-- Электронная подпись -->
        <div class="col-xl-4 col-md-6">
          <card class="h-100 mb-0">
            <div class="row mb-2">
              <div class="col-auto">
                <div class="icon icon-shape text-white rounded-circle shadow"
                     style="background-image: url(/img/icons/2.png); height: 48px; width: 48px; background-position: center"><i class="fas fa-signature"></i></div>
              </div>
              <div class="col ml--2 d-flex align-items-center" style="height: 48px">
                <h3 class="mb-0">Электронная подпись</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-body mb-1">КЭП или НЭП <sup>скоро</sup></p>
                <p class="text-body mb-0">Подписание договоров, контрактов и других документов любого формата и размера.
                </p>
              </div>
            </div>
          </card>
        </div>

        <!-- Криптография ГОСТ 2012 -->
        <div class="col-xl-4 col-md-6">
          <card class="h-100 mb-0">
            <div class="row mb-2">
              <div class="col-auto">
                <div class="icon icon-shape text-white rounded-circle shadow"
                     style="background-image: url(/img/icons/3.png); height: 48px; width: 48px; background-position: center"><i class="fas fa-check"></i></div>
              </div>
              <div class="col ml--2 d-flex align-items-center" style="height: 48px">
                <h3 class="mb-0">Криптография ГОСТ 2012</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-body mb-1">Поддержка российского сертифицированного криптопровайдера "КриптоПро CSP"</p>
                <p class="text-body mb-0"></p>
              </div>
            </div>
          </card>
        </div>
      </div>

      <!-- 4-6 cards -->
      <div class="row mb-5">

        <!-- Кроссплатформенность -->
        <div class="col-xl-4 col-md-6">
          <card class="h-100 mb-0">
            <div class="row mb-2">
              <div class="col-auto">
                <div class="icon icon-shape text-white rounded-circle shadow"
                     style="background-image: url(/img/icons/4.png); height: 48px; width: 48px; background-position: center"><i class="fas fa-laptop-code"></i></div>
              </div>
              <div class="col ml--2 d-flex align-items-center" style="height: 48px">
                <h3 class="mb-0">Кроссплатформенность</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-body mb-1">Приложения доступны для устройств: iOS, Android, macOS и Windows.</p>
                <p class="text-body mb-0">Данные синхронизируются между устройствами пользователя.</p>
              </div>
            </div>
          </card>
        </div>

        <!-- Расширяемость -->
        <div class="col-xl-4 col-md-6">
          <card class="h-100 mb-0">
            <div class="row mb-2">
              <div class="col-auto">
                <div class="icon icon-shape text-white rounded-circle shadow"
                     style="background-image: url(/img/icons/5.png); height: 48px; width: 48px; background-position: center"><i class="fas fa-clone"></i></div>
              </div>
              <div class="col ml--2 d-flex align-items-center" style="height: 48px">
                <h3 class="mb-0">Расширяемость</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-body mb-1">Чат-боты и возможность интегрировать мессенджер Командор в любую информационную систему.</p>
                <p class="text-body mb-0"></p>
              </div>
            </div>
          </card>
        </div>

        <div class="col-xl-4 col-md-6">
          <card class="h-100 mb-0">
            <div class="row mb-2">
              <div class="col-auto">
                <div class="icon icon-shape text-white rounded-circle shadow"
                     style="background-image: url(/img/icons/6.png); height: 48px; width: 48px; background-position: center"><i class="fab fa-node-js"></i></div>
              </div>
              <div class="col ml--2 d-flex align-items-center" style="height: 48px">
                <h3 class="mb-0">Открытое API</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-body mb-1">Модуль "Командор CSP" для Node.js и открытое API для разработки собственных клиентских приложений.</p>
                <p class="text-body mb-0"></p>
              </div>
            </div>
          </card>
        </div>

      </div>
    </div>


    <div>
      <div class="bg-danger">
      <div class="container">
        <div class="row mb-4">
          <div class="col mt-6">
            <h1 class="text-center text-white">Защита и конфиденциальность</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-6 mb-6">
            <h2 style="font-weight: 100" class="mb-2 text-white ml-4">
              Мессенджер предназначен для обмена важными или конфиденциальными данными с надежным сквозным шифрованием, а
              также возможностью подписывать сообщения и файлы квалифицированной (КЭП) и не квалифицированной (НЭП) электронной подписью.</h2>
          </div>
          <div class="col-6">
            <h2 style="font-weight: 100" class="mb-2 text-white mr-4">
              Все сообщения обязательно шифруются на стороне клиента.  Командор защищает ваши конфиденциальные данные от
              просмотра посторонними лицами, злоумышленниками, а также администраторами сервиса.
            </h2>
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="bg-bottom"></div>

  </div>
</template>
<script>
  import Logo from '@/views/Components/Logo'
  import Card from '@/components/Cards/Card'

  import EditProfileForm from './UserProfile/EditProfileForm.vue';
  import UserCard from './UserProfile/UserCard.vue';
  import ProgressTrackList from '@/views/Dashboard/ProgressTrackList';

  export default {
    components: { Logo, Card, EditProfileForm, UserCard, ProgressTrackList },
    data () {
      return {
        // color: 'rgb(255,255,255, 1)'
        color: '#ced4da'
      }
    },
  };
</script>
<style>
  .index-header {
    background-image: url(/img/komandor.jpg);
    background-size: cover;
    background-position: center top;
    min-height: 600px;
  }
  .bg-red {
    background-color: #ff442b;
  }
  .bg-bottom {
    background-image: url(/img/bg-b.jpg);
    background-size: cover;
    background-position: center top;
    min-height: 400px;
  }
</style>
